import { ErrorMessage } from '@gc-bridge/components/ErrorMessage';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { App } from './app/App';
import { setupApp } from './app/setup';

export async function main() {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

  try {
    const { redirectInProgress } = (await setupApp()) ?? {};

    if (redirectInProgress) {
      return;
    }

    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } catch (error) {
    console.error(error);
    root.render(<ErrorMessage message="An error occurred on the application startup." />);
  }
}
